import Style from './container.module.scss';
import { useNode } from '@craftjs/core';
import { FormContainerComponent } from 'src/features/generalForms/builder/types/Container';

export const RootContainer: FormContainerComponent = ({ children }) => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
    isFirstNode: node.id === 'ROOT',
  }));

  // The Frame color is now set via CSS to support themes.
  const { ...otherStyles } = styles;

  return (
    <div className={Style.root} style={otherStyles}>
      {children}
    </div>
  );
};
